import Rate from '@/components/Rate';

export const MaybeRating = ({
  rating_summary,
  review_count,
  showReview,
}: {
  rating_summary: number;
  review_count: number;
  showReview: boolean;
}) => {
  if (!showReview) {
    return null;
  }

  if (!review_count) {
    return null;
  }

  return (
    <div className='flex items-center'>
      <Rate
        disabled
        initialRating={rating_summary / 20}
      />
      <span className='ml-[10px] font-sans text-sm leading-[1.4] text-[#666]'>
        {review_count} <span className='hidden lg_inline'>Reviews</span>
      </span>
    </div>
  );
};
